import { BlankSlate } from "@msuite/ui/blank-slate";
import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { FileCardRemote } from "@/components/files";
import { useReturnOrderFiles } from "@/hooks/use-return-order-files";

/** Props Interface */
interface ReturnOrderSheetProps {
	returnOrderId: string;
}

/**
 * The sheet a return run prints — one PDF carrying the run's QR code and one page per lorry. The
 * card downloads only: the sheet is replaced by the server whenever the run's fleet changes, so
 * what is offered here is always the document naming the trucks actually going.
 */
export function ReturnOrderSheet({ returnOrderId }: ReturnOrderSheetProps) {
	/** Context */
	const { t } = useTranslation();

	/** Query */
	const { files } = useReturnOrderFiles(returnOrderId);

	/** Render */
	return (
		<ContentCard
			title={t("stock.return_sheets")}
			icon={icon("Printer")}
			variant="plain"
		>
			{files.length === 0 ? (
				<BlankSlate
					label={t("stock.no_return_sheets")}
					withAccessory={false}
				/>
			) : (
				<div className="flex flex-col gap-2">
					{files.map((file) => (
						<FileCardRemote
							variant="content-card"
							key={file.id}
							fileId={file.id}
							onInteraction={null}
							withRemove={false}
						/>
					))}
				</div>
			)}
		</ContentCard>
	);
}
